import createIcon from '../../createIcon';

/**
 * @component @name ShieldMoon
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMkw0IDVWMTEuMDlDNCAxNi4xNCA3LjQxIDIwLjg1IDEyIDIyQzE2LjU5IDIwLjg1IDIwIDE2LjE0IDIwIDExLjA5VjVMMTIgMlpNMTUuOTcgMTQuNDFDMTQuMTMgMTYuNTggMTAuNzYgMTYuNTEgOS4wMSAxNC4zNEM2LjgyIDExLjYyIDguMzYgNy42MiAxMS43IDcuMDFDMTIuMDQgNi45NSAxMi4zMyA3LjI4IDEyLjIxIDcuNjFDMTEuNzUgOC44NCAxMS44MiAxMC4yNSAxMi41MyAxMS40N0MxMy4yNCAxMi42OSAxNC40MiAxMy40NiAxNS43MSAxMy42N0MxNi4wNSAxMy43MiAxNi4yIDE0LjE0IDE1Ljk3IDE0LjQxWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ShieldMoon = createIcon('ShieldMoon', [
  [
    'path',
    {
      d: 'M12 2L4 5V11.09C4 16.14 7.41 20.85 12 22C16.59 20.85 20 16.14 20 11.09V5L12 2ZM15.97 14.41C14.13 16.58 10.76 16.51 9.01 14.34C6.82 11.62 8.36 7.62 11.7 7.01C12.04 6.95 12.33 7.28 12.21 7.61C11.75 8.84 11.82 10.25 12.53 11.47C13.24 12.69 14.42 13.46 15.71 13.67C16.05 13.72 16.2 14.14 15.97 14.41Z',
      key: '18o92l',
    },
  ],
]);

export default ShieldMoon;
